// extracted by mini-css-extract-plugin
export default {"Container":"Federal_Container__UYKSi","section-1":"Federal_section-1__a466T","content":"Federal_content__SseJD","section-2":"Federal_section-2__FmuQn"};